import * as React from "react";
const SvgFiRrDiamondExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-diamond-exclamation_svg__a)">
      <path
        fill="#062147"
        d="m22.536 8.46-7-7a4.97 4.97 0 0 0-3.535-1.466A4.97 4.97 0 0 0 8.465 1.46l-7 7.001a5.004 5.004 0 0 0 0 7.07l7 7A4.97 4.97 0 0 0 12 23.995a4.97 4.97 0 0 0 3.536-1.465l6.999-7A4.97 4.97 0 0 0 24 11.994c0-1.335-.52-2.59-1.464-3.535m-1.414 5.655-7 7.001c-1.133 1.133-3.11 1.133-4.243 0l-7-7a3.003 3.003 0 0 1 0-4.242l7-7A2.98 2.98 0 0 1 12 1.993a2.98 2.98 0 0 1 2.122.88l6.999 7A2.98 2.98 0 0 1 22 11.995c0 .802-.312 1.554-.878 2.12M13.5 16.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3 .001m-2.5-4V7a1 1 0 1 1 2 0v5.5a1 1 0 1 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-diamond-exclamation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiamondExclamation;
